import React, { useState, useEffect, useRef, useMemo } from 'react';
import {
  Box,
  Container,
//   Fade,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

// Shared Components
import SectionTitle from './shared/SectionTitle';
import BannerCard from './shared/BannerCard';
import LoadingSkeleton from './shared/LoadingSkeleton';

const BannerSection = ({ section, isLoading }) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const observerRef = useRef(null);
  const bannerRef = useRef(null);

  const items = useMemo(() => section?.items || [], [section?.items]);

  const handleBannerClick = (item) => {
    if (item.link_url) {
      navigate(item.link_url);
    }
  };

  // Intersection Observer for fade-in animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            // Once visible, we can stop observing
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (bannerRef.current) {
      observer.observe(bannerRef.current);
      observerRef.current = observer;
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []); // Empty dependency array - only run once

  if (isLoading) {
    return (
      <LoadingSkeleton 
        type="banner"
        height={300}
        showTitle={true}
      />
    );
  }

  if (!items.length) return null;

  return (
    <Box sx={{ py: 6 }}>
      <Container maxWidth="lg">
        {/* Section Title with Animation */}
        <SectionTitle 
          title={section.title}
          align="center"
        />

        {/* Banner with Animation */}
        <Box
          ref={bannerRef}
          data-banner-animate
          sx={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0) scale(1)' : 'translateY(30px) scale(0.95)',
            transition: 'all 0.8s cubic-bezier(0.4, 0, 0.2, 1)',
            transformOrigin: 'center center',
          }}
        >
          <BannerCard
            banner={items[0]}
            onClick={handleBannerClick}
            showOverlay={true}
            showButton={true}
            buttonText="shopNow"
          />
        </Box>
      </Container>
    </Box>
  );
};

export default BannerSection;
